import React, {Component} from 'react';
import { injectIntl } from 'react-intl';
import Hero from 'components/heroes/hero';
import Text from 'components/text/text';
import AccountInfo from 'pages/profile/_account-info';
import RiderProfiles from 'pages/profile/_rider-profiles';
import Page from 'components/page/page';
import messages from './messages';

class Profile extends Component {
  constructor(props) {
    super(props);

    const { intl } = props;

    /**
     * TODO: Once Profiles are ready to be built, uncomment
     * the into message and delete the coming soon intro
     */
    this.page = {
      'heading': intl.formatMessage(messages.heading),
      // 'intro': 'Edit your account information and rider profiles.'
      'intro': intl.formatMessage(messages.intro)
    };
  }

  _renderHero() {
    return (
      <Hero title={this.page.heading} supportingTxt={this.page.intro} />
    )
  }

  /**
   * TODO: Once Profiles are ready to be built, uncomment
   * the below code and take fullTexture off of the Page props
   */
  render() {
    const pageHero = this._renderHero();

    return (
      <Page
        fullTexture
        title={this.page.heading}
        pageHero={pageHero}
      />
      //   <div className="container">
      //     <AccountInfo />
      //     <RiderProfiles />
      //   </div>
      // </Page>
    );
  }
}

export default injectIntl(Profile);



// WEBPACK FOOTER //
// ./src/client/pages/profile/profile.jsx